import ApiCore from '../api-core'
import { ACTIVE_BASE_REST } from '../constants'

export default class ReportsStatistics extends ApiCore {
  constructor(store) {
    super(store, `${ ACTIVE_BASE_REST }/report/statistics`)
  }

  getStatistics(showProgress) {
    return this._request({
      action: '',
      method: 'GET',
      showProgress
    })
  }
}
